<template>
    <div>
        <div>
            <h2 class="text-center m-0 py-3 text-default">
                Historique des activités médico-administratives (AMA)
            </h2>
        </div>
        
        <div class="content__trajet bg-white shadow mt-5">
            <h2 class="text-center m-0 py-3 text-default">
                Activités Administratives Manuelles
            </h2>
            <hr class="m-0" />
            <div class="px-1 px-md-4 py-4">
                <div class="row justify-content-center px-md-6">
                    <div class="col-12 col-md-6 col-lg mr-md-2 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="recherchez par date....." 
                            v-model="searchDateM"/>
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                    <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="Rechercher par package de ligne de temps....." 
                             v-model="searchManuel"/>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="px-1 px-md-6 py-4 content__scroll">
                    <div class="trajet__box accordion" role="tablist" v-for="(affiliation, index) in activite_ama_manuelles" :key="index">
                        <div v-for="(ligne_temps, key) in affiliation.ligne_temps" :key="index+'-'+key" v-if="ligne_temps.activites_ama_patients.length >0">
                            <div v-b-toggle="'accordion'+index+'_'+key" class="trajet__info trajet__active mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center">
                                <div class="trajet__info--text d-flex align-items-center fs-6">
                                    <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                    <span class="text-primary px-1">{{ formattedDate(ligne_temps.date_consultation) }}</span>
                                    <span class="text-default ml-0 ml-md-5">{{ affiliation.package.description_fr }} ({{ formattedDate(affiliation.date_signature) }})</span>
                                    <span class="px-5 d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default">{{ ligne_temps.motif.description }}</span>
                                </div>
                                <li class="trajet__info--state trajet__active--state"></li>
                            </div>
                            <b-collapse :id="'accordion'+index+'_'+key" class="mt-1" visible accordion="my-accordion" role="tabpanel">
                                <b-card class="border-0">
                                    <div>
                                        <ul class="trajet__item p-0 px-md-4" v-for="(item, index) in ligne_temps.activites_ama_patients" :key="index">
                                            <li class="d-flex l-none align-items-center p-0">
                                                <span class="text-muted d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i> ---- </span>
                                                <div class="trajet__item--box mx-2 px-2">
                                                    <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                                    <span class="text-primary px-1">{{ formattedDateTime(item.created_at) }}</span>
                                                    <span class="text-default w-100">
                                                        <p><span class="font-weight-bold">Activité:</span> {{ item.activites_ama.description_fr }}</p>
                                                        <p><span class="font-weight-bold">Commentaire:</span> {{ item.commentaire }}</p>
                                                        <p v-if="item.date_cloture"><span class="font-weight-bold">Date clôture:</span> {{ formattedDate(item.date_cloture) }}</p> 
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </b-card>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div> 
        </div>

         <div class="content__trajet bg-white shadow mt-5">
            <h2 class="text-center m-0 py-3 text-default">
                Activités Administratives Automatiques
            </h2>
            <hr class="m-0" />
            <div class="px-1 px-md-4 py-4">
                <div class="row justify-content-center px-md-6">
                    <div class="col-12 col-md-6 col-lg mr-md-2 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="recherchez par date....." 
                             v-model="searchAutoD"/>
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                    <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="Rechercher par package de ligne de temps....." 
                             v-model="searchAuto"/>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="px-1 px-md-6 py-4 content__scroll">
                    <div class="trajet__box accordion" role="tablist" v-for="(affiliation, index) in filterAuto" :key="index">
                        <div v-for="(ligne_temps, key) in affiliation.ligne_temps" :key="index+'-'+key" v-if="ligne_temps.rendez_vous.length >0">
                            <div v-b-toggle="'accordion'+index+'-'+key" class="trajet__info trajet__active mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center">
                                <div class="trajet__info--text d-flex align-items-center fs-6">
                                    <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                    <span class="text-primary px-1">{{ formattedDate(ligne_temps.date_consultation) }}</span>
                                    <span class="text-default ml-0 ml-md-5">{{ affiliation.package.description_fr }} ({{ formattedDate(affiliation.date_signature) }})</span>
                                    <span class="px-5 d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                    <span class="text-default">{{ ligne_temps.motif.description }}</span>
                                </div>
                                
                            </div>
                            <b-collapse :id="'accordion'+index+'-'+key" class="mt-1" visible accordion="my-accordion" role="tabpanel">
                                <b-card class="border-0">
                                    <div>
                                        <ul class="trajet__item p-0 px-md-4" v-for="(item, index) in ligne_temps.rendez_vous" :key="index">
                                            <li class="d-flex l-none align-items-center p-0">
                                                <span class="text-muted d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i> ---- </span>
                                                <div class="trajet__item--box mx-2 px-2">
                                                    <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                                    <span class="text-primary px-1">{{ formattedDateTime(item.date) }}</span>
                                                    <span class="text-default">
                                                            <span class="font-weight-bold">Rendez-vous </span>
                                                            pris pour la date du <span class="font-weight-bold">{{ formattedDateTime(item.date).split('à')[0] }} </span>
                                                            à <span class="font-weight-bold">{{ formattedDateTime(item.date).split('à')[1] }} </span>
                                                            avec <span class="font-weight-bold" v-if="item.praticien">{{ item.praticien.prenom +' '+item.praticien.nom }} </span>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </b-card>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div> 
         </div>

        <div class="content__trajet bg-white shadow">
            <h2 class="text-center m-0 py-3 text-default">
               Activités Administratives isolées (n'appartenant à aucune affiliation)
            </h2>
            <hr class="m-0" />
            <div class="px-1 px-md-4 py-4">
                <div class="row justify-content-center px-md-6">
                    <div class="col-12 col-md-6 col-lg mr-md-2 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="recherchez par date....." 
                             v-model="searchDate"/>
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                    <div class="col-12 col-md-6 col-lg my-2 my-md-0 d-flex align-items-center border-primary border rounded px-2">
                        <input type="text" class="form-control border-0" 
                            placeholder="Rechercher par motif de ligne de temps....." 
                             v-model="searchTrajet"/>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="px-1 px-md-6 py-4 content__scroll">
                    <div class="trajet__box accordion" role="tablist" v-for="(activity, index) in filterTrajet" :key="index">
                        <div v-b-toggle="'accordion'+index" class="trajet__info trajet__active mt-2 px-2 px-md-4 d-flex justify-content-between align-items-center">
                            <div class="trajet__info--text d-flex align-items-center fs-6">
                                <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                <span class="text-primary px-1">{{ activity.created_at }}</span>
                                <span class="text-default ml-0 ml-md-5">{{ activity.motif }}</span>
                            </div>
                            <li class="trajet__info--state trajet__active--state"></li>
                        </div>
                        <b-collapse :id="'accordion'+index" class="mt-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card class="border-0">
                                <div>
                                    <ul class="trajet__item p-0 px-md-4">
                                        <li class="d-flex l-none align-items-center p-0">
                                            <span class="text-muted d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i> ---- </span>
                                            <div class="trajet__item--box mx-2 px-2">
                                                <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                                <span class="text-primary px-1">{{ formattedDateTime(activity.date_cloture) }}</span>
                                               
                                                <span class="text-default w-100">
                                                    <p v-if="activity.createur">
                                                        Fait par <span class="font-weight-bold">{{ activity.createur.prenom.charAt(0).toUpperCase() + activity.createur.prenom.slice(1) }} {{ activity.createur.nom.toUpperCase() }}</span>
                                                    </p>
                                                    <p v-if="activity.etablissement">
                                                        <span class="font-weight-bold">Etablissement: </span>
                                                        <span v-html="activity.etablissement.name"></span>
                                                    </p>
                                                    <p v-if="activity.ligne_temps">
                                                        <span class="font-weight-bold">Ligne de temps: </span>
                                                        <span v-html="activity.ligne_temps.motif.description"></span>
                                                    </p>
                                                    <p v-if="activity.commentaire">
                                                        <span class="font-weight-bold">Commentaire:</span> {{ activity.commentaire }}
                                                    </p>
                                                   <!--  <p v-if="item.date_cloture"><span class="font-weight-bold">Date clôture:</span> {{ formattedDate(item.date_cloture) }}</p>  -->
                                                </span>

                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                </div>
            </div> 
        </div>

        
    </div>
  
</template>
<script>
import search from "@/_services/trajetService";

import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import moment from "moment";
export default {
    name: "TrajetMedicoAdministratif",

    components: {},

    computed: {},
    props: ['dossier_medical_slug'],
    data() {
        return {
            activite_ama_automatiques: [],
            activite_ama_isoles: [],
            activite_ama_manuelles: [],
            activites_medecin : [],
            activite_automatique : [],
            searchTrajet: "",
            searchDate: null,
            searchManuel: "",
            searchDateM: null,
            searchAuto: "",
            searchAutoD: null,
        }
    },
    methods: {
        formattedDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return date;
            }
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getActiviteAmas(dossier_medical_slug){
            axios.get(`${AppConfig.apiUrl}/v1/parcours/${dossier_medical_slug}/activite_amas`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
            .then(res => {
                this.activite_ama_automatiques = res.data.activite_ama_automatiques;
                this.activite_ama_isoles = res.data.activite_ama_isoles;
                this.activite_ama_manuelles = res.data.activite_ama_manuelles;

                    if (res.data.activite_ama_isoles.length > 0) {
                        let activite_ama_isoles = [];
                        res.data.activite_ama_isoles.forEach(i => {
                            activite_ama_isoles.push({
                                motif: i.activites_ama.description_fr,
                                date_cloture: this.formattedDate(i.date_cloture),
                                created_at: this.formattedDate(i.created_at),
                                createur: i.createur,
                                etablissement: i.etablissement,
                                ligne_temps: i.ligne_temps,
                                commentaire: i.commentaire,
                            })
                        });
                            
                        this.activites_medecin = activite_ama_isoles;
                    }

                    if (res.data.activite_ama_manuelles) {
                        let activite_ama_manuelles = [];
                        this.activite_ama_manuelles.forEach(j => {
                            activite_ama_manuelles.push({
                                created_at: j.date_signature,
                            })
                        });
                        this.activites_manuel = this.activite_ama_manuelles;
                        // console.log(this.activites_manuel);
                    }

                    if (res.data.activite_ama_automatiques) {
                        let activite_ama_automatiques = [];
                        res.data.activite_ama_automatiques.forEach(item => {
                            activite_ama_automatiques.push({
                                created_at: item.date_signature,
                            })
                        });
                        this.activite_automatique = this.activite_ama_automatiques;
                    }
            })
            .catch((error) => {
                    //console.log("error ", error)
            });
        }
    },
    mounted() {
        this.getActiviteAmas(this.dossier_medical_slug);
    },
    computed: {
        filterTrajet() {
            return search(this.searchTrajet, this.searchDate, this.activites_medecin, this.activity)
        },

        filterAuto() {
            const query = this.searchAuto.toLowerCase()
            const req = this.searchAutoD;
            if(this.searchAuto === "" && this.searchAutoD === null){
                return this.activite_automatique;
            }else{
                if(this.searchAuto !== ""){
                    return this.activite_automatique.filter((affiliation) => {
                        return affiliation.package.description_fr.toLowerCase().includes(query);
                    })
                }
                if(this.searchAutoD !== null){
                    return this.activite_automatique.filter((affiliation) => {
                        return affiliation.date_signature.includes(req)
                    })
                
                }
            }
        },

        filterManuels() {
            const query = this.searchManuel.toLowerCase()
            const req = this.searchDateM;
            if(this.searchManuel === "" && this.searchDateM === null){
                return this.activites_manuel;
            }else{
                if(this.searchManuel !== ""){
                    return this.activites_manuel.filter((affiliation) => {
                        return affiliation.package.description_fr.toLowerCase().includes(query);
                    })
                }
                if(this.searchDateM !== null){
                    return this.activites_manuel.filter((affiliation) => {
                        return affiliation.date_signature.includes(req)
                    })
                }
            }
        },
    }
}
</script>
<style>
    
</style>